// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1vaKW","colBig":"styles_colBig__1H5Bw","colSmall":"styles_colSmall__3F7tI"};